import React, { useState } from "react";
import "./add-employee-modal.css";
import { showToast } from "../toasts/ToastNotification";
import { ClipLoader } from "react-spinners";
import { createNewEmployee } from "../../api/user.api";

const AddEmployeeModal = ({ isOpen, onClose, title, setEmployees }) => {
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState("editor");

    const handleClose = () => {
        if (loading) return;
        onClose();
    };

    const handleAddNewEmployee = async () => {
        setLoading(true);

        try {
            let res = await createNewEmployee(selected);

            if (res.success) {
                showToast("Thêm mới thành công", "success");
                setEmployees((prev) => ([
                    ...prev,
                    res.data.newEmployee
                ]));
                onClose();
            }
        } catch (error) {
            showToast(error.message, "error");
        } finally {
            setLoading(false);
        }
    }

    if (!isOpen) return null;

    return (
        <div className="admin-employee-modal-overlay">
            <div className="admin-employee-modal">
                <div className="admin-employee-modal-head">
                    <h2 className="admin-employee-modal-title">{title}</h2>
                    <p className="admin-employee-modal-message">
                        Tên đăng nhập và email tạo tự động. Mật khẩu mặc định là <strong>admin123</strong>.
                    </p>
                </div>

                <div className="admin-employee-modal-field">
                    <label>Vai trò nhân viên</label>
                    <select
                        className="admin-employee-modal-select"
                        value={selected}
                        onChange={(e) => setSelected(e.target.value)}
                    >
                        <option value={"editor"}>Editor</option>
                        <option value={"supporter"}>Supporter</option>
                    </select>
                </div>

                <div className="admin-employee-modal-actions">
                    <button
                        disabled={loading}
                        className="admin-employee-modal-btn admin-employee-modal-btn-ghost"
                        onClick={handleClose}
                    >
                        Hủy
                    </button>
                    <button
                        disabled={loading}
                        className="admin-employee-modal-btn admin-employee-modal-btn-primary"
                        onClick={handleAddNewEmployee}
                    >
                        {loading ? <ClipLoader size={18} color="#fff" /> : "Thêm"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddEmployeeModal;
